if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends customElements.get('slider-default') {
    constructor() {
      super();
    }

    connectedCallback() {
      this.handleBreakpointChange = this.resetSlider.bind(this);

      this.initSlider();

      breakpointTablet.addEventListener('change', this.handleBreakpointChange);
    }

    disconnectedCallback() {
      breakpointTablet.removeEventListener(
        'change',
        this.handleBreakpointChange,
      );
    }

    initSlider() {
      this.sliderOptions.mousewheel = true;
      this.sliderOptions.direction = breakpointTablet.matches
        ? 'vertical'
        : 'horizontal';
      this.sliderOptions.freeMode = breakpointTablet.matches;

      super.initSlider();
    }

    resetSlider() {
      this.slider.destroy();
      this.initSlider();
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
}
